import React, { useEffect, useRef, useState } from "react";
import Datatable from "components/Core/DataTable";
import Select from "react-select";
import "../assets/scss/react/_buttons.scss"
import Spinner from 'react-bootstrap/Spinner';
// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col,
	Modal,
	ModalBody,
	ModalHeader,
	Form,
	FormGroup,
	CustomInput,
	ModalFooter,
	Button,
	Label,
	Input
} from "reactstrap";
import Auth from "lib/Core/Backend/Controllers/Auth";
import Notify from "lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import { MotionButton } from "components/Core/MotionStrap";
import FormValidator from "lib/Utils/FormValidator";
import ConfirmationAlert from "components/ConfirmationAlert/ConfirmationAlert";
import ConfirmationAlertTwo from "components/ConfirmationAlert/ConfirmationAlertTwo";

let userRoles = [
    "SYSTEM_MANAGER",
    "INTERNAL_MANAGER",
    "PRODUCT_MANAGER",
    "SUPPLIER_MANAGER",
    "COMMERCIAL_MANAGER",
    "ACCOUNTANT_MANAGER",
    "CUSTOMER_SERVICE",
]

let permissions = {
    "SYSTEM_MANAGER": [
			"CAN_DELETE_PURCHASER",
			"CAN_LIST_FUNDS",
      "CAN_DELETE_INVENTORY",
      "CAN_CREATE_BRAND",
      "CAN_CREATE_USER",
      "CAN_LIST_INVENTORY",
      "CAN_LIST_GIFT_CARD",
      "CAN_LIST_USER",
      "CAN_EDIT_BRAND",
      "CAN_CREATE_SUPPLIER",
      "CAN_EDIT_INVENTORY",
      "CAN_CREATE_CATEGORY",
      "CAN_CREATE_PURCHASE_ORDER",
      "CAN_EDIT_CATEGORY",
      "CAN_LIST_PURCHASER",
      "CAN_DELETE_CATEGORY",
      "CAN_LIST_CATEGORY",
      "CAN_BLOCK_USER",
      "CAN_EDIT_GIFT_CARD",
      "CAN_LIST_PURCHASE_ORDER",
      "CAN_EDIT_USER",
      "CAN_DELETE_PURCHASE_ORDER",
      "CAN_EDIT_PURCHASER",
      "CAN_LIST_SUPPLIER",
      "CAN_LIST_BRAND",
      "CAN_CREATE_INVENTORY",
      "CAN_DELETE_BRAND",
      "CAN_DELETE_SUPPLIER",
      "CAN_EDIT_PURCHASE_ORDER",
      "CAN_CREATE_GIFT_CARD",
      "CAN_EDIT_SUPPLIER",
      "CAN_DELETE_GIFT_CARD",
      "CAN_DELETE_USER",
      "CAN_CREATE_PURCHASER"
		],
    "INTERNAL_MANAGER": [
			"CAN_DELETE_PURCHASER",
			"CAN_LIST_FUNDS",
      "CAN_DELETE_INVENTORY",
      "CAN_CREATE_BRAND",
      "CAN_CREATE_USER",
      "CAN_LIST_INVENTORY",
      "CAN_LIST_GIFT_CARD",
      "CAN_LIST_USER",
      "CAN_EDIT_BRAND",
      "CAN_CREATE_SUPPLIER",
      "CAN_EDIT_INVENTORY",
      "CAN_CREATE_CATEGORY",
      "CAN_CREATE_PURCHASE_ORDER",
      "CAN_EDIT_CATEGORY",
      "CAN_LIST_PURCHASER",
      "CAN_DELETE_CATEGORY",
      "CAN_LIST_CATEGORY",
      "CAN_BLOCK_USER",
      "CAN_EDIT_GIFT_CARD",
      "CAN_LIST_PURCHASE_ORDER",
      "CAN_EDIT_USER",
      "CAN_DELETE_PURCHASE_ORDER",
      "CAN_EDIT_PURCHASER",
      "CAN_LIST_SUPPLIER",
      "CAN_LIST_BRAND",
      "CAN_CREATE_INVENTORY",
      "CAN_DELETE_BRAND",
      "CAN_DELETE_SUPPLIER",
      "CAN_EDIT_PURCHASE_ORDER",
      "CAN_CREATE_GIFT_CARD",
      "CAN_EDIT_SUPPLIER",
      "CAN_DELETE_GIFT_CARD",
      "CAN_DELETE_USER",
      "CAN_CREATE_PURCHASER"
		],
    "PRODUCT_MANAGER": [
			"CAN_LIST_FUNDS",
      "CAN_DELETE_INVENTORY",
      "CAN_CREATE_BRAND",
      "CAN_LIST_INVENTORY",
      "CAN_LIST_GIFT_CARD",
      "CAN_EDIT_BRAND",
      "CAN_CREATE_SUPPLIER",
      "CAN_EDIT_INVENTORY",
      "CAN_CREATE_CATEGORY",
      "CAN_EDIT_CATEGORY",
      "CAN_DELETE_CATEGORY",
      "CAN_LIST_CATEGORY",
      "CAN_EDIT_GIFT_CARD",
      "CAN_LIST_SUPPLIER",
      "CAN_LIST_BRAND",
      "CAN_CREATE_INVENTORY",
      "CAN_DELETE_BRAND",
      "CAN_DELETE_SUPPLIER",
      "CAN_CREATE_GIFT_CARD",
      "CAN_EDIT_SUPPLIER",
      "CAN_DELETE_GIFT_CARD",
		],
    "SUPPLIER_MANAGER": [
			"CAN_LIST_FUNDS",
      "CAN_CREATE_BRAND",
      "CAN_LIST_GIFT_CARD",
      "CAN_EDIT_BRAND",
      "CAN_CREATE_SUPPLIER",
      "CAN_CREATE_CATEGORY",
      "CAN_CREATE_PURCHASE_ORDER",
      "CAN_EDIT_CATEGORY",
      "CAN_DELETE_CATEGORY",
      "CAN_LIST_CATEGORY",
      "CAN_EDIT_GIFT_CARD",
      "CAN_LIST_PURCHASE_ORDER",
      "CAN_DELETE_PURCHASE_ORDER",
      "CAN_LIST_SUPPLIER",
      "CAN_LIST_BRAND",
      "CAN_DELETE_BRAND",
      "CAN_DELETE_SUPPLIER",
      "CAN_EDIT_PURCHASE_ORDER",
      "CAN_CREATE_GIFT_CARD",
      "CAN_EDIT_SUPPLIER",
      "CAN_DELETE_GIFT_CARD",
		],
    "COMMERCIAL_MANAGER": [
			"CAN_DELETE_PURCHASER",
			"CAN_LIST_FUNDS",
      "CAN_DELETE_INVENTORY",
      "CAN_CREATE_BRAND",
      "CAN_LIST_INVENTORY",
      "CAN_LIST_GIFT_CARD",
      "CAN_EDIT_BRAND",
      "CAN_EDIT_INVENTORY",
      "CAN_CREATE_CATEGORY",
      "CAN_EDIT_CATEGORY",
      "CAN_LIST_PURCHASER",
      "CAN_DELETE_CATEGORY",
      "CAN_LIST_CATEGORY",
      "CAN_EDIT_GIFT_CARD",
      "CAN_EDIT_PURCHASER",
      "CAN_LIST_BRAND",
      "CAN_CREATE_INVENTORY",
      "CAN_DELETE_BRAND",
      "CAN_CREATE_GIFT_CARD",
      "CAN_DELETE_GIFT_CARD",
      "CAN_CREATE_PURCHASER"
		],
    "ACCOUNTANT_MANAGER": [
			"CAN_LIST_FUNDS",
      "CAN_EDIT_FUNDS",
		],
    "CUSTOMER_SERVICE": [
      "CAN_LIST_INVENTORY",
		],
}

function Users()
{
	let accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
	let token = accessToken.token
	const authCtl = new Auth(token);
	const [users, setUsers] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [usersLoading, setUsersLoading] = useState(true);
	const [userRolesModal, setUserRolesModal] = useState(false);
	const [createUserModal, setCreateUserModal] = useState(false);
	const [warningModal,setWarningModal] = useState(false)
	const [roles, setRoles] = useState([]);
	const [role, setRole] = useState(null);
	const [activeUser, setActiveUser] = useState(null);
	const [disableSelect, setDisableSelect] = useState(false);
	const [reload, setReload] = useState(false);
	const [modalConfirmation, setModalConfirmation] = useState(false);
	const [operativeRow, setOperativeRow] = useState({});
	const [userCreateLoading, setUserCreateLoading] = useState(false);
	const [userEditLoading, setUserEditLoading] = useState(false);
	const [deleteUserLoading, setDeleteUserLoading] = useState(false);
	const [loader,setLoader] = useState(true)	

	const toggleUserRolesModal = () => setUserRolesModal(prev => !prev)
	const toggleCreateUserModal = () => setCreateUserModal(prev => !prev)
	const toggleWarning = () => setWarningModal(!warningModal)

	const header = [
		{title: 'Email', data: 'email', sortable: true, searchable: true},
		{title: 'Role', data: 'roles', sortable: true, searchable: true, render: data => {
			if(data.includes('SYSTEM_MANAGER')){
				return 'System Manager'
			} else if(data.includes('INTERNAL_MANAGER')){
				return 'Internal Manager'
			} else if(data.includes('PRODUCT_MANAGER')){
				return 'Product Manager'
			}	else if(data.includes('SUPPLIER_MANAGER')){
				return 'Supplier Manager'
			} else if(data.includes('COMMERCIAL_MANAGER')){
				return 'Commercial Manager'
			} else if(data.includes('ACCOUNTANT_MANAGER')){
				return 'Accountant Manager'
			} else if(data.includes('CUSTOMER_SERVICE')){
				return 'Customer Service'
			} else {
				return 'User'
			}
		}},
		{title: 'Account Status', data: 'enabled', sortable: true, searchable: true, render: data => data ? 'Active' : 'Inactive'}
	];

	const table = useRef();
	const alert = useRef();
	const form = useRef();
	const userForm = useRef();
	const roleSelect = useRef();

	const prepareForm = (row) => {
		let user = row.data();
		setActiveUser(user)
		setRoles(userRoles.map((role) => ({value: role, label: role.replaceAll('_' ,' ')  })))
		setRole(null)
		setDisableSelect(false)
		toggleUserRolesModal()
	}

	const onOpened = () => {
		if(!activeUser)
			return
		
		if(!form.current)
			return

		form.current['active'].checked = activeUser?.enabled

		let roles = activeUser.roles;
		let selectedRole = userRoles.find(role => roles.includes(role))
		setRole(selectedRole)
		selectedRole && roleSelect.current.setValue({value: selectedRole, label: selectedRole})

		let loggedInUser = accessToken.decodedToken.username
		setDisableSelect(loggedInUser === activeUser?.username)
	}

	const editUserLoading=()=>{
		setTimeout(()=>{
			setUserEditLoading(false)
		}, 1500)
	}
	const finishOperation = (e) => {
		setUserEditLoading(true)
		e.preventDefault()
		// e.target.disabled = true
		if(!activeUser){
			editUserLoading()
			return
		}
		
		if(!form.current){
			editUserLoading()
			return
		}
		
		let selectedRole = roleSelect.current.getValue()

		if(selectedRole.length === 0){
			Notify(alert, 'danger', 'Please select a role')
			editUserLoading()
			// e.target.disabled = false
			return
		}

		const toggleActive = (reload) => {
			if(activeUser.enabled !== form.current.active.checked){
				authCtl.toggleActive(activeUser.username, data => {
					if(data?.status === 403){
						toggleWarning();
						editUserLoading()
						return;
					}
					// e.target.disabled = false
					if(data.errorMessage || data.error){
						Notify(alert, 'danger', data.errorMessage ?? data.error)
						editUserLoading()
					} else {
						toggleUserRolesModal();
						setReload(prev => !prev)
						editUserLoading()
					}
				})
			} else {
				toggleUserRolesModal()
				reload && setReload(prev => !prev)
				editUserLoading()
			}
		}

		if(selectedRole[0]?.value === role){
			editUserLoading()
			toggleActive()
		} else {
			let rolePermissions =  permissions[selectedRole[0]?.value]
			let addGroups = rolePermissions
			let removeGroups = activeUser.permissions
			removeGroups.push(...activeUser.roles)
			addGroups.push(selectedRole[0]?.value)
			removeGroups = removeGroups.filter(g => g !== 'admin')
			sendGroups(addGroups, removeGroups, activeUser.username, () =>{
				setUserEditLoading(false)
				toggleActive(true)})
		}
	}

	const sendGroups = (addGroups, removeGroups, username, done) => {
		let i = 0
		if(removeGroups[i]){
			const removeGroup = () => {
				let removeData = {
					username,
					role: removeGroups[i]
				}
				authCtl.removeFromGroup(removeData, data => {
					if(data?.status === 403){
						toggleWarning();
						return;
					}
					if(data.errorMessage || data.error){
					Notify(alert, 'danger', data.errorMessage ?? data.error)
					}
					if(removeGroups[++i]){
						removeGroup()
					} else {
						let addInfo = {
							username: username,
							roles: addGroups
						}
						authCtl.addToGroup(addInfo, addData => {
							if(addData?.status === 403){
								toggleWarning();
								return;
							}
							if(addData.errorMessage || addData.error){
								Notify(alert, 'danger', addData.errorMessage ?? addData.error)
							}
							done()
						})
					}
				})
			}
			removeGroup()
		} else {
			let addInfo = {
				username: username,
				roles: addGroups
			}
			authCtl.addToGroup(addInfo, addData => {
				if(addData?.status === 403){
					toggleWarning();
					return;
				}
				if(addData.errorMessage || addData.error){
					Notify(alert, 'danger', addData.errorMessage ?? addData.error)
				}
				done()
			})
		}
	}

	const toggleConfirm = () => setConfirmModal(!confirmModal);

	function remove(row)
	{
		setOperativeRow(row);
		toggleConfirm();
	}

	function deleteLoadingUser(){
		setTimeout(()=>{
			setDeleteUserLoading(false)
		}, 1500)
	}
	function confirmRemoval()
	{
		setDeleteUserLoading(true)
		const row = operativeRow;
				const email = row.data().email;
        const payload = { username: email };
		authCtl.deleteUser(payload, data =>
		{
			if(data?.status === 403){
				deleteLoadingUser()
				toggleWarning();
				toggleConfirm();
				return;
			}
			if (!data || data.error !== null)
			{
				if (data.status === 500){
					Notify(alert, "danger", "You cannot remove this User.");
					deleteLoadingUser()
				}
				else{
					Notify(alert, "danger", data.error);
					deleteLoadingUser()
				}
			} else
			{
				toggleConfirm();
				Notify(alert, "success", 'User deleted successfully');
				deleteLoadingUser()
				table.current.dataTable.row(row).remove().draw();
				setOperativeRow(null);
				
			}
			
		});
	}

	const prepareToAdd = () => {
		toggleCreateUserModal()
	}

	const createLoadingUser = () => {
		setTimeout(()=>{
			setUserCreateLoading(false)
		}, 1500)
	}

	const createUser = (e) => {
		setUserCreateLoading(true)
		e.preventDefault()
		// e.target.disabled = true
		if(!userForm.current)
			return
		
		const uForm = new FormValidator(userForm.current, (type, message) => Notify(alert, type, message), [
			{label: "First Name", property: "firstName", input: 'firstName', required: true},
			{label: "Last Name", property: "lastName", input: 'lastName', required: true},
			{label: "Email", property: "username", input: 'userEmail', required: true},
			{label: "Phone number", property: "phoneNumber", input: 'userPhone', required: true},
		])

		const firstNameValue = userForm.current.firstName.value;
		const lastNameValue = userForm.current.lastName.value;
        const regex = /^[A-Za-z]([A-Za-z].*[A-Za-z])?$/;
		const phoneRegex = /^\+\d{1,3}\d{10}$/;

			if(userForm.current.firstName.value === "" && userForm.current.lastName.value === "" && userForm.current.email.value === "" && userForm.current.phone.value === ""){
				Notify(alert,"danger","All field are required")
				createLoadingUser()
				return
			}else if(!regex.test(firstNameValue)){
				Notify(alert,"danger","Please enter valid first name containing only alphabetic character")
				createLoadingUser()
				return
			}else if(userForm.current.lastName.value === ""){
				Notify(alert,"danger","Lastname field is required")
				createLoadingUser()
				return
			}else if(!regex.test(lastNameValue)){
				Notify(alert,"danger","Please enter valid last name containing only alphabetic character")
				createLoadingUser()
				return
			}else if(userForm.current.email.value === ""){
				Notify(alert,"danger","Email field is required")
				createLoadingUser()
				return
			}else if (userForm.current.phone.value === ""){
				Notify(alert,"danger","Phone Number field is required")
				createLoadingUser()
				return
			}else if (!phoneRegex.test(userForm.current.phone.value)){
				Notify(alert,"danger","Please enter a valid phone number")
				createLoadingUser()
				return
			}
		const userData = uForm.getDTO();
		const modifiedUserData = {
			...userData,
			username: userData?.username?.toLowerCase(),
		  };
	
		authCtl.createUser(modifiedUserData, data => {
			if(data?.status === 403){
				toggleWarning();
				createLoadingUser()
				return;
			}
			if(data.errorMessage || data.error){
				Notify(alert, 'danger', data.errorMessage ?? data.error)
				createLoadingUser()
				// e.target.disabled = false
			} else {
				Notify(alert, 'success', 'User Succesfully created')
				toggleCreateUserModal()
				setReload(prev => !prev)
				createLoadingUser()
			}
		})
	}

	const closeModalConfirmation = () => {
		setModalConfirmation(false)
	}

	const closeAllModals = () => {
		setCreateUserModal(prev => prev ? false : prev)
		setUserRolesModal(prev => {
			if(prev){
				setActiveUser(null);
				return false
			}
			return	prev
		})
		setModalConfirmation(false)
	}

	useEffect(() => {
		setUsersLoading(true)
			authCtl.internalUsers(data => {
				if(data.error || data.errorMessage){
					setLoader(false)
					Notify(alert, 'danger', data.errorMessage ?? data.error);
				} else {
					setLoader(false)
					setUsersLoading(false)
					setUsers(data)
				}
			})
	}, [reload]);

	useEffect(() => {
		if(!usersLoading){
			if(table.current){
				table.current && table.current.dataTable.clear().rows.add(users).draw();
				table.current && table.current.clearSearch()
			}
		}
	}, [usersLoading, users]);

	return (<div className="content">
		<Row>
			<ReactNotificationAlert ref={alert} />
			<Col md="12">
				<Card>
					<CardHeader  className="d-flex justify-content-between">
						<CardTitle tag="h4">Ncentiva Platform Full User List</CardTitle>
							<Col md="auto" className="justify-content-end text-align-right">
							<MotionButton initial={{ x: "-500%", opacity: 0 }} 
									className="add_brand btn btn-primaryTwo" 
									animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }} 
								 
									onClick={prepareToAdd}>
									<i className="fas fa-plus" />{' '}Create new User
						</MotionButton>
						</Col>
					</CardHeader>
					<CardBody>
						
					{loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:	
					
						<div className="data_table">
						<Datatable
								ref={table}
								columns={header}
								data={null}
								options={{
									saveState: false,
									dom: 'tip'
								}}
								addRemoveButton={{callback: remove}}
								addEditButton={{callback: prepareForm}}
								enableSelectFilters={true}
							/>
						</div>
                    }
					</CardBody>
				</Card>
			</Col>
		</Row>
		<Modal isOpen={userRolesModal} toggle={toggleUserRolesModal} centered={true} size='md' onOpened={onOpened} backdrop='static'>
			<ModalHeader>User Roles</ModalHeader>
			<ModalBody>
				<Form className="mx-5" innerRef={form} disabled>
					<h5 className="text-center">Select a role for this user</h5>
					<Row className="mx-3 justify-content-center">
						<Col md={7}>
							<FormGroup>
								<Select
									id="role"
									ref={roleSelect}
									options={roles}
									isDisabled={disableSelect}
									menuPortalTarget={document.body} 
    							styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
									isClearable
									isMulti={false}
								/>
							</FormGroup>
						</Col>
						
					</Row>
					<Row className="mt-4 mx-3 justify-content-center">
						<FormGroup>
							<CustomInput
								type="checkbox"
								label='is User Active'
								id='active'
								disabled={disableSelect}
							/>
						</FormGroup>
					</Row>
				</Form>
			</ModalBody>
			<ModalFooter>
				<Button type="button" color="secondary" className="mr-3" onClick={() => setModalConfirmation(true)}>Cancel</Button>
				<Button type="button" className="btn btn-primaryTwo" onClick={finishOperation} disabled={userEditLoading}>{!userEditLoading && "Save"}
					{userEditLoading && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}</Button>
			</ModalFooter>
		</Modal>
		<Modal isOpen={createUserModal} toggle={toggleCreateUserModal} centered={true} size='lg' backdrop='static'>
			<ModalHeader className="custom_header_colourTwo" toggle={toggleCreateUserModal}>Create New User  </ModalHeader>
			<ModalBody>
				<Form className="mx-5" innerRef={userForm}>
					<Row form>
						<Col md={6}>
							<FormGroup>
								<Label for="firstName">First Name <span style={{color:"red",fontSize:"15px"}}>*</span></Label>
								<Input type="text" name="firstName" id="firstName" maxLength="70"  placeholder="User First Name"/>
							</FormGroup>
						</Col>
						<Col md={6}>
							<FormGroup>
								<Label for="lastName">Last Name <span style={{color:"red",fontSize:"15px"}}>*</span></Label>
								<Input type="text" name="lastName" id="lastName" maxLength="70" placeholder="User Last Name"/>
							</FormGroup>
						</Col>
						<Col md={6}>
							<FormGroup>
								<Label for="userEmail">Email <span style={{color:"red",fontSize:"15px"}}>*</span></Label>
								<Input type="email" name="email" id="userEmail" placeholder="Type User Email" />
							</FormGroup>
						</Col>
						<Col md={6}>
							<FormGroup>
								<Label for="userPhone">Phone <span style={{color:"red",fontSize:"15px"}}>*</span></Label>
								<Input type="tel" name="phone" id="userPhone" placeholder="User Phone Number" maxLength="14" className="custom-input"/>
							</FormGroup>
						</Col>
					</Row>
					
				</Form>
			</ModalBody>
			<ModalFooter>
				<Button type="button" color="secondary" className="mr-3" onClick={() => setModalConfirmation(true)}>Cancel</Button>
				<Button type="button" className="btn btn-primaryTwo" onClick={!userCreateLoading && createUser} disabled={userCreateLoading}>{!userCreateLoading && "Save"}
					{userCreateLoading && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}</Button>
			</ModalFooter>
		</Modal>
		<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>Remove User</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the user "{!!operativeRow && !!operativeRow.data ? operativeRow.data().email : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button className="btn btn-primaryTwo" onClick={confirmRemoval} disabled={deleteUserLoading}>{!deleteUserLoading && "Yes"}{
						deleteUserLoading && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}</Button>
				</ModalFooter>
			</Modal>
			<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>
		<ConfirmationAlertTwo stayModal={closeModalConfirmation} openModal={modalConfirmation} leaveModal={closeAllModals} />
	</div>);
}

export default Users;
